/* eslint-disable @next/next/no-img-element */

import React from 'react';

import { Spacer } from '@repo/ui/components/Spacer';
import { H4 } from '@repo/ui/components/Typography';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';

import { ImageRow, ImageDefault, ImageDark } from './styles';

const Brands = ({ slice, context }) => {
  return (
    <ContentWrapper
      background={slice?.primary?.background ?? 'offWhite'}
      className="brands"
      customWidth="1440px"
      forceDarkModeContent={context.forceDarkModeContent}
    >
      <H4 style={{ textAlign: 'center' }}>
        {slice.primary.title || 'Used by brands like'}
      </H4>
      <Spacer height="46px" />
      <ImageRow>
        <ImageDefault alt="Warner Bros" src="/images/brands/warner.svg" />
        <ImageDefault
          alt="Harley Davidson"
          src="/images/brands/harleyDavidson.svg"
        />
        <ImageDefault alt="Netflix" src="/images/brands/netflix.svg" />
        <ImageDefault alt="Milka" src="/images/brands/milka.svg" />
        <ImageDefault alt="Ogilvy" src="/images/brands/ogilvy.svg" />
        <ImageDefault
          alt="Ravensburger"
          src="/images/brands/ravensburger.svg"
        />
        <ImageDefault alt="Penguin" src="/images/brands/penguin.svg" />

        <ImageDark alt="Warner Bros" src="/images/brands/warnerDark.svg" />
        <ImageDark
          alt="Harley Davidson"
          src="/images/brands/harleyDavidsonDark.svg"
        />
        <ImageDark alt="Netflix" src="/images/brands/netflixDark.svg" />
        <ImageDark alt="Milka" src="/images/brands/milkaDark.svg" />
        <ImageDark alt="Ogilvy" src="/images/brands/ogilvyDark.svg" />
        <ImageDark
          alt="Ravensburger"
          src="/images/brands/ravensburgerDark.svg"
        />
        <ImageDark alt="Penguin" src="/images/brands/penguinDark.svg" />
      </ImageRow>
    </ContentWrapper>
  );
};

export default Brands;
